import cx from 'classnames';
import { TypographyTextProps } from './types';
import { getCommonClassName } from './utils';
import { ElementType } from 'react';

export const Text = <T extends ElementType = 'div'>({
  children,
  size = 'medium',
  component,
  className,
  strong,
  shadow,
  italic,
  color,
  align,
  textWrap,
  transform,
  ellipsis,
  underlineOnHover,
  ...props
}: TypographyTextProps<T>) => {
  const Component = component || 'span';
  return (
    <Component
      className={cx(
        {
          [`slds-text-body--${size}`]: size !== 'medium',
          'slds-text-body--regular': size === 'medium'
        },
        getCommonClassName({
          strong,
          shadow,
          italic,
          color,
          className,
          align,
          textWrap,
          transform,
          ellipsis,
          underlineOnHover
        })
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
